import { Outlet } from "@tanstack/react-router";
import { UpdateBanner } from "../components/UpdateBanner";

// Kitchen Display is a fixed-station board (tablet/TV), not a phone app —
// unlike the other portals it owns its own full-viewport chrome per screen
// (gate phases vs. the board), so the root layout stays a plain host.
export function RootLayout() {
  return (
    <div className="cq-full-height" style={{ width: "100%", overflow: "hidden" }}>
      <UpdateBanner />
      <Outlet />
    </div>
  );
}
